window.addEventListener('load', function(){

	const contactForm =  document.getElementsByName('contactForm');
	const sejaParceiroForm =  document.getElementsByName('sejaParceiroForm');
	let url;

	if (location.hostname === "localhost" || location.hostname === "127.0.0.1"){
		url = 'http://localhost:8000/support/tickets/submit';
	}else{
		url = 'https://api.mendelics.com.br/support/tickets/submit';
	}

	if (contactForm.length) {

		const validation = new JustValidate('#contactForm');
		validation
			.addField('#nome', [
				{rule: 'minLength', value: 5},
				{rule: 'required', errorMessage: '*Este campo es obligatorio'}
			])
			.addField('#email', [
				{rule: 'required', errorMessage: '*Este campo es obligatorio'},
				{rule: 'email', errorMessage: '*Email está invalido'}
			])
			.addField('#telefone', [
				{rule: 'required', errorMessage: '*Este campo es obligatorio'},
				{rule: 'number', errorMessage: '*Telefone está invalido'}
			])
			.addField('#empresa', [
				{rule: 'required', errorMessage: '*Este campo es obligatorio'},
			])
			.addField('#subject', [
				{rule: 'required', errorMessage: '*Este campo es obligatorio'}
			])
			.addField('#comentarios', [
				{rule: 'required', errorMessage: '*Este campo es obligatorio'}
			]);


		// Alterar cor do "placehgolder" do selectbox
		document.getElementsByName('subject')[0].addEventListener('change', function(event){
			if(event.target.selectedIndex == 0) {
				event.target.classList.add('text-graystronger'); 
			} else {
				event.target.classList.remove('text-graystronger');
			}
		});
	
		// Submeter formulario FaleConosco
		contactForm[0].addEventListener('submit', function (event) {
			if(contactForm[0].checkValidity()){
				// layout adjustment var config
				document.getElementById('submit-btn').disabled = true;
				const formDefaultElements = document.querySelectorAll('#formSubmitSuccessMessege, #formSubmitErrorMessege, #formTextEnviar');
				const formTransitionElements = document.querySelectorAll('#formTextEnviando, #formSpinner');
				// execute layout adjustment
				formDefaultElements.forEach(element => {
					element.classList.add('hidden');
				});
				formTransitionElements.forEach(element => {
					element.classList.remove('hidden');
					element.classList.add('inline');
				});
				// submit form
				const payload = {
					form: 'teste_da_bochechinha_contato', //nome do form no api
					subject: 'Contato via Website Examen Primer Dia, SAC - ' + document.getElementsByName('subject')[0].value,
					tags: ['form-sac-examenprimerdia'],
					name: document.getElementsByName('nome')[0].value,
					email:  document.getElementsByName('email')[0].value,
					phone_number:  document.getElementsByName('telefone')[0].value,
					instituicao:  document.getElementsByName('empresa')[0].value,
					assunto:  document.getElementsByName('subject')[0].value,
					description: document.getElementsByName('comentarios')[0].value,
					site_lang: 'es'
				};
				
				var payloadJson = JSON.stringify(payload);

				fetch(url, {
					method: 'POST',
					body: payloadJson,
					headers: {
						'Content-Type': 'application/json',
						'Data-Type': 'json',
						'Process-Data': false
					},
				})
				.then((response) => {
					contactForm[0].reset();
					document.getElementById('submit-btn').disabled = false;
					formTransitionElements.forEach(element => {
						element.classList.remove('inline');
						element.classList.add('hidden');
					});
					document.getElementById('formTextEnviar').classList.remove('hidden');
					document.getElementsByName('subject')[0].classList.add('text-graystronger');
					if (response.ok) {	
						document.getElementById('formSubmitSuccessMessege').classList.remove('hidden')
						return response;
					} 
					else if (!response.ok) {
						document.getElementById('formSubmitErrorMessege').classList.remove('hidden')
						throw Error(response.statusText)
					}
				})
				.then( 
					( response ) => response.json() 
				)
				event.preventDefault();
			}
		});
	}

	if(sejaParceiroForm.length) {

		const validation = new JustValidate('#sejaParceiroForm');
		validation
			.addField('#nome', [
				{rule: 'minLength', value: 5},
				{rule: 'required', errorMessage: '*Este campo es obligatorio'}
			])
			.addField('#email', [
				{rule: 'required', errorMessage: '*Este campo es obligatorio'},
				{rule: 'email', errorMessage: '*Email está invalido'}
			])
			.addField('#telefone', [
				{rule: 'required', errorMessage: '*Este campo es obligatorio'},
				{rule: 'number', errorMessage: '*Telefone está invalido'}
			])
			.addField('#empresa', [
				{rule: 'minLength', value: 5},
				{rule: 'required', errorMessage: '*Este campo es obligatorio'}
			])
			.addField('#comentarios', [
				{rule: 'required', errorMessage: '*Este campo es obligatorio'}
			]);

		// Submeter formulario Parceiro
		sejaParceiroForm[0].addEventListener('submit', function (event) {
			if(sejaParceiroForm[0].checkValidity()){
				// layout adjustment var config
				document.getElementById('submit-btn').disabled = true;
				const formDefaultElements = document.querySelectorAll('#formSubmitSuccessMessege, #formSubmitErrorMessege, #formTextEnviar');
				const formTransitionElements = document.querySelectorAll('#formTextEnviando, #formSpinner');
				// execute layout adjustment
				formDefaultElements.forEach(element => {
					element.classList.add('hidden');
				});
				formTransitionElements.forEach(element => {
					element.classList.remove('hidden');
					element.classList.add('inline');
				});

				// submit form
				const payload = {
					form: 'teste_da_bochechinha_seja_parceiro', //nome do form no api
					subject: 'Contato via Website Examen Primer Dia - Parceiros',
					tags: ['form-parceiros-examenprimerdia'],
					name: document.getElementsByName('nome')[0].value,
					email:  document.getElementsByName('email')[0].value,
					phone_number:  document.getElementsByName('telefone')[0].value,
					instituicao:  document.getElementsByName('empresa')[0].value,
					description: document.getElementsByName('comentarios')[0].value,
					site_lang: 'es'
				};
		
				var payloadJson = JSON.stringify(payload);
		
				fetch(url, {
					method: 'POST',
					body: payloadJson,
					headers: {
						'Content-Type': 'application/json',
						'Data-Type': 'json',
						'Process-Data': false
					},
				})
				.then((response) => {
					sejaParceiroForm[0].reset(),
					document.getElementById('submit-btn').disabled = false;
					formTransitionElements.forEach(element => {
						element.classList.remove('inline');
						element.classList.add('hidden');
					});
					document.getElementById('formTextEnviar').classList.remove('hidden');
					if (response.ok) {	
						document.getElementById('formSubmitSuccessMessege').classList.remove('hidden')
						return response;
					} 
					else if (!response.ok) {
						document.getElementById('formSubmitErrorMessege').classList.remove('hidden')
						throw Error(response.statusText)
					}
				})
				.then( 
					( response ) => response.json() 
				)
				event.preventDefault();
			}
		});

	}

});